module.exports = __webpack_public_path__ + "static/img/17.50f6978b.jpg";